import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import styles from "./ErrorModal.module.scss";

const ErrorModalView = ({ errors }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {errors?.map(({ id, data }) => (
        <div key={id} className={styles.descriptionCont}>
          {t(id) && isNaN(Number(t(id))) ? t(id, data) : t("SERVER_ERROR")}
        </div>
      ))}
    </div>
  );
};

ErrorModalView.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.string,
      data: PropTypes.object
    })
  ).isRequired
};

export default ErrorModalView;
